import { cssTransition } from "react-toastify";

/**
 * Signature-eased slide-from-edge toast transition (GON-6388 motion polish).
 *
 * Replaces react-toastify's default ~750ms Bounce with the app's motion
 * standard: enter eases out from the right edge over 260ms, exit is quicker
 * (160ms). The keyframes + reduced-motion fallback live in
 * `styles/reactToastify.css` (`gondola-toast-enter` / `gondola-toast-exit`).
 */
export const signatureToast = cssTransition({
  enter: "gondola-toast-enter",
  exit: "gondola-toast-exit",
});
